module.exports = {
	requestLimit: 'REQUEST_LIMIT',
	enableSingleUse: 'ENABLE_SINGLEUSE',
	enableMultiUse: 'ENABLE_MULTIUSE',
	enableSubscriptions: 'ENABLE_SUBSCRIPTIONS',
	pauseVirtualCardCreation: 'PAUSE_VIRTUAL_CARD_CREATION',
};
